// extracted by mini-css-extract-plugin
export default {"socials":"SocialAuth_socials__-FTkL","socialsButton":"SocialAuth_socialsButton__CTs0L"};